module.exports = __webpack_public_path__ + "static/media/pescador-partitura.a16de10d.png";